import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const cisaKev = defineConnector({
  identifier: "cisaKev",
  name: "CISA KEV",
  tagLine: "Known exploited vulnerabilities",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(
      baseUrl || "https://www.cisa.gov/sites/default/files/feeds"
    ),
  auth: headerAuth([]),
  steps: [
    {
      title: "Set up CISA KEV",
      items: [
        {
          kind: "markdown",
          content:
            "This public JSON feed requires no credentials. Use the default feed URL. See the [Known Exploited Vulnerabilities catalog](https://www.cisa.gov/known-exploited-vulnerabilities-catalog).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          defaultValue: "https://www.cisa.gov/sites/default/files/feeds",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the canonical CISA KEV Catalog page to confirm the current feed location. The documented JSON feed is https://www.cisa.gov/sites/default/files/feeds/known_exploited_vulnerabilities.json; CISA does not document regional API hosts.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://www.cisa.gov/sites/default/files/feeds")
          .trim()
          .replace(/\/+$/, "") + "/known_exploited_vulnerabilities.json",
      ...{ method: "GET", expectedBodyContains: ['"vulnerabilities"'] },
    }),
  },
});
